import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

/**
 * RedirectIfAuthenticated
 *
 * Purpose: Keeps authenticated users away from public auth pages.
 * Used by: App route configuration.
 */
function RedirectIfAuthenticated({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="p-6 text-sm text-text-faint">Loading session...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

RedirectIfAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RedirectIfAuthenticated;
